import { useEffect } from 'react';

export function useModalShownParentNotification(isShown: boolean, domain: string) {
  useEffect(() => {
    if (isShown) {
      notifyParentModalShown();
    }
  }, [isShown]);

  function notifyParentModalShown() {
    const targetOrigin =
      process.env.REACT_APP_BUILD_ENV === 'prod'
        ? `https://support.${domain}`
        : 'https://zooplusdev.freshdesk.com';
    const event = {
      type: 'modal-shown',
    };
    window.top.postMessage(event, targetOrigin);
  }
}
